<div class="file-name-download-main">
    <span (click)="download(file)" [innerHTML]="file.name">{{file.name}}</span>
    <em> ({{file.filesize}})</em>
</div>
